import React from "react";
import { Svg } from "../../Core/Svg/Svg";
import { icons, getColorFromVariantKey, } from "@clearabee/ui-library-base";
import { theme } from "../../theme";
const IconComponent = ({ color, size = "xlarge", children, ...rest }) => {
    const props = {
        color: !!color ? getColorFromVariantKey(color) : undefined,
        "aria-label": "Supporting Icon",
        width: theme.spacing[size],
        height: theme.spacing[size],
        ...rest,
    };
    return React.createElement(Svg, { ...props }, children);
};
Object.entries(icons).forEach(([iconName, icon]) => {
    IconComponent[iconName] = ({ ...rest }) => React.createElement(Icon, { ...icon, ...rest });
});
export const Icon = IconComponent;
//# sourceMappingURL=Icon.js.map